import { DOCUMENT, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformId: object,
    private gtmService: GoogleTagManagerService,
    private router: Router
  ) {}

  init() {
    this.trackInitOriginalLocation();

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const isPortrait = window.matchMedia('(orientation: portrait)').matches;

        const gtmTag = {
          event: 'virtualPageview',
          virtualPageURL: event.url,
          virtualPageTitle: this.document.title,
          orientation: isPortrait ? 'Portrait' : 'Landscape',
          devicePixelRatio: window.devicePixelRatio,
        };

        this.gtmService.pushTag(gtmTag).catch(() => {});
      }
    });
  }

  trackInitOriginalLocation() {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    const gtmTag = {
      originalLocation:
        this.document.location.protocol +
        '//' +
        this.document.location.hostname +
        this.document.location.pathname +
        this.document.location.search,
    };

    this.gtmService.pushTag(gtmTag).catch(() => {});
  }
}
